import React from 'react'
import { useRecoilValue, useRecoilCallback } from 'recoil'

import styled from '@emotion/styled'

import {
  Button,
  ModalHead,
  ModalBody,
  ModalFoot,
  FormElement,
  Select,
  EmptyState
} from 'mailup-web-components'

import {
  modalBeeContentDialogState,
  sourcesFeedbackState,
  emptyStateState,
  validStep1State
} from '../recoil/state'

import {
  onChangeSourceCallback,
  modalContentDialogConfirmCallback,
  modalContentDialogStep2Callback
} from '../recoil/callbacks'

import { useIntl } from 'react-intl'

import {
  LayoutInputContentsPerRow,
  LayoutInputImagePosition
} from './LayoutConfigFields'

import LayoutInputContentsRepeat from './LayoutInputContentsRepeat'

import ErrorFeedback from './ErrorFeedback'

import emptyStateImage from 'mailup-web-components/resources/mailup-web-app/img/svg/empty-state-campaign.svg'

const InputSourceFormElement = styled(FormElement)`
  margin-top: 20px;
  margin-bottom: 20px;
  padding: 0 30px;

  & label {
    font-size: 18px;
    font-weight: 400;
    color: var(--mine-shaft);
    letter-spacing: 0.04em;
    line-height: 1.2em;
  }
`

const InputSelectLayoutFormElement = styled(FormElement)`
  padding: 0 30px;

  & label {
    font-size: 18px;
    font-weight: 400;
    color: var(--mine-shaft);
    letter-spacing: 0.04em;
    line-height: 1.2em;
  }
`

const InputSelectLayoutRepeatFormElement = styled(FormElement)`
  margin-bottom: 20px;
  padding: 0 30px;
`

const LayoutConfig = () => {
  const intl = useIntl()
  const { sources, sourceId, error, severity } = useRecoilValue(
    modalBeeContentDialogState
  )
  const onSourceChange = useRecoilCallback(onChangeSourceCallback, [])
  const handleConfirm = useRecoilCallback(modalContentDialogConfirmCallback, [])

  const handleChooseContents = useRecoilCallback(
    modalContentDialogStep2Callback,
    []
  )

  const { feedback, feedbackVariant } = useRecoilValue(sourcesFeedbackState)
  const emptyState = useRecoilValue(emptyStateState)
  const validStep1 = useRecoilValue(validStep1State)

  return (
    <>
      <ModalHead
        title={intl.formatMessage({
          id: 'Load.BeeContentDialog.SelectContentsFromSource'
        })}
      />
      {error ? (
        <>
          <ModalBody>
            <ErrorFeedback error={error} severity={severity} />
          </ModalBody>
          <ModalFoot />
        </>
      ) : (
        <>
          {!emptyState && (
            <>
              <ModalBody>
                <InputSourceFormElement
                  required
                  labelFor='select-source'
                  label={intl.formatMessage({
                    id: 'Load.BeeContentDialog.SelectSource'
                  })}
                  feedback={feedback}
                  feedbackVariant={feedbackVariant}
                >
                  <Select
                    id='select-source'
                    value={sourceId}
                    options={sources}
                    onChange={onSourceChange}
                    placeholder={intl.formatMessage({
                      id: 'Load.Common.Select'
                    })}
                  />
                </InputSourceFormElement>

                <InputSelectLayoutFormElement
                  required
                  labelFor='select-layoyut'
                  label={intl.formatMessage({
                    id: 'Load.BeeContentDialog.SelectTemplate'
                  })}
                >
                  <LayoutInputContentsPerRow />
                  <LayoutInputImagePosition />
                </InputSelectLayoutFormElement>

                <InputSelectLayoutRepeatFormElement>
                  <LayoutInputContentsRepeat />
                </InputSelectLayoutRepeatFormElement>
              </ModalBody>
              <ModalFoot>
                <Button
                  kind='secondary'
                  onClick={handleChooseContents}
                  disabled={!validStep1}
                >
                  {intl.formatMessage({
                    id: 'Load.BeeContentDialog.ChooseContents'
                  })}
                </Button>
                <Button
                  kind='primary'
                  onClick={handleConfirm}
                  disabled={!validStep1}
                >
                  {intl.formatMessage({
                    id: 'Load.BeeContentDialog.InsertLastContents'
                  })}
                </Button>
              </ModalFoot>
            </>
          )}
          {emptyState && (
            <EmptyState
              thumbSrc={emptyStateImage}
              title={intl.formatMessage({
                id: 'Load.BeeContentDialog.EmptyStateTitle'
              })}
              description={intl.formatMessage(
                {
                  id: 'Load.BeeContentDialog.EmptyStateDescr'
                },
                {
                  linebreak: <br />
                }
              )}
            />
          )}
        </>
      )}
    </>
  )
}

export default LayoutConfig
